import React, { useState, useEffect } from "react";
import arrow from "../../assets/borrow/arrow.svg";
import dash from "../../assets/borrow/dash.svg";
import approve from "../../assets/borrow/approve.svg";
import back from "../../assets/borrow/back.svg";
import next from "../../assets/borrow/next.svg";
import { useBorrow } from "../../contexts/borrowContext/borrowContext";
import { useNavigate } from "react-router-dom";
import { approveAccount } from "../../lib/stcContract";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDashboard } from "../../contexts/dashboardContext";

function VaultMgt({
  onNextButtonClicked,
  onLoaded,
  _glmrBalance,
  _glmrPrice,
  _colRatio,
  _maxSTC,
  _account,
  _stc,
  _stb,
  _fromDashborrow,
  _setFromDashborrow,
}) {
  const navigate = useNavigate();
  const { handleLoading } = useDashboard();
  const { calculateAmounts, resetVaultBorrowSetup } = useBorrow();
  const [glmrIn, setglmrIn] = useState(null);
  const [stcOut, setStcOut] = useState(null);
  const [hntFee, setHntFee] = useState(null);
  const [isApproved, setIsApproved] = useState(false);

  const approveBtn = document.getElementById("approve-btn");
  const nextBtn = document.getElementById("vm-next-btn");

  //sets glmr amount, gets and sets returned STC
  const handleInputglmr = (e) => {
    let input = e.target.value;
    setglmrIn(parseFloat(input));
    const haunterFee = (10 / 100) * input;
    setHntFee(haunterFee);
    const stcOut = input / _colRatio;
    setStcOut(stcOut.toFixed(4));
  };

  //handles approve button colour change
  const handleNextButtonColour = () => {
    if (_account && _stc && nextBtn) {
      if (stcOut > 0) {
        nextBtn.style.backgroundColor = "#009FBD";
      } else {
        nextBtn.style.backgroundColor = "#585858";
      }
    }
  };

  handleNextButtonColour();

  //handles next button click
  const handleNextButton = async () => {
    if (nextBtn.style.backgroundColor === "rgb(0, 159, 189)") {
      onNextButtonClicked();
    }
  };

  return (
    <div>
      <div className="flex items-center  pt-[2.5vh] px-[34px] gap-[16px] text-sm">
        <div className="bg-[#292c31] py-[2.8vh] px-[24px] w-[400px] rounded-[12px] h-full  ">
          <h1 className="text-[#009FBD] text-center font-bold ">
            Configure your Vault
          </h1>
          <p className="text-center mb-[2.6vh] ">
            Simulate your vault by configuring the amount of collateral to
            deposit.
          </p>
          <div className=" mb-[2.1vh] ">
            <div className="flex items-center justify-between mb-1">
              <p>Deposit glmr</p>
              <p className="text-[#865dff] ">
                Balance: <span className="text-white">{_glmrBalance}</span>
              </p>
            </div>
            <div className="w-full relative text-[#292C31]">
              <input
                onInput={(e) => {
                  handleInputglmr(e);
                }}
                onChange={calculateAmounts(glmrIn, stcOut, hntFee)}
                type="number"
                placeholder="Enter Amount"
                className="w-full bg-[#D5D5D5] rounded-[7px] h-[5.46vh] px-[21px] placeholder:text-[#292C31]  "
              />
              <h1 className="absolute top-1 right-[21px] font-semibold">GLMR</h1>
            </div>
          </div>

          <div className="bg-[#202225] flex flex-col items-center py-[1vh] rounded-[12px] ">
            <h1 className="text-[#865DFF] text-center font-bold ">
              Generated STC
            </h1>
            <p className="mb-[2.75px]">
              Max: <span>{_maxSTC} STC</span>
            </p>
            <div className=" relative text-[#292C31]">
              <input
                type="number"
                className="w-[302px] bg-[#D5D5D5] rounded-[7px] h-[5.46vh] px-[21px]  "
                value={stcOut}
              />
              <h1 className="absolute top-1 right-[21px] font-semibold">STC</h1>
            </div>
          </div>
          <img src={dash} alt="" className="my-[1.4vh]" />
          <h1 className="text-[#865DFF] text-center font-bold ">
            Vault Changes
          </h1>
          <div className="text-xs">
            <div className="flex justify-between items-center">
              <h1>Total Debt:</h1>
              <small>$0.00 → {stcOut}</small>
            </div>
            <div className="flex justify-between items-center">
              <h1>Haunter's fee:</h1>
              <small>0.00 → {hntFee}</small>
            </div>
            <div className="flex itme justify-between items-center">
              <h1>Annual interest:</h1>
              <small>0.00 → 0.15%</small>
            </div>
          </div>
        </div>
        <div>
          <img src={arrow} alt="" className="w-[30px]" />
        </div>

        <div className="bg-[#292c31] py-[12px] px-[24px] w-[400px] rounded-[12px]  h-full">
          <h1 className="text-[#009FBD] text-center font-bold ">Approve STB</h1>
          <p className="text-center mb-[2.76vh] ">
            Simulate your vault by configuring the amount of collateral to
            deposit.
          </p>
          <p className="text-center mb-[2vh] ">
            <span className="text-[#865DFF] ">Note:</span> STB is only approved
            to transfer the collateral amount passed not less or more than.
          </p>
          <div className="flex flex-wrap justify-between gap-y-[1.3vh]  text-xs ">
            <div className="w-[160px]  h-[8vh] bg-[#202225] rounded-[10px] py-[1.6vh] px-[13px] ">
              <h1 className="text-xs">Total Debt:</h1>
              <p className="font-bold">${stcOut}</p>
            </div>
            <div className="w-[160px]  h-[8vh] bg-[#202225] rounded-[10px] py-[1.6vh] px-[13px] ">
              <h1 className="text-xs">Collateralization Ratio:</h1>
              <p className="font-bold">{_colRatio}</p>
            </div>
            <div className="w-[160px]  h-[8vh] bg-[#202225] rounded-[10px] py-[1.6vh] px-[13px] ">
              <h1 className="text-xs">Current Price:</h1>
              <p className="font-bold">${_glmrPrice}</p>
            </div>
            <div className="w-[160px]  h-[8vh] bg-[#202225] rounded-[10px] py-[1.6vh] px-[13px] ">
              <h1 className="text-xs">Liquidation Price:</h1>
              <p className="font-bold">${_glmrPrice}</p>
            </div>
          </div>
          <div className="text-[0.625rem] my-[2.27vh] text-[#865DFF] text-center italic leading-tight">
            Thanks to Moonbeam Batch Precompiled Contracts you don’t have to
            click on approval button anymore, both approval and Borrow function
            will be handled on confirmation page. Click next to proceed
          </div>
          <div className="flex items-center justify-center">
            <button
              id="approve-btn"
              className="w-[10.31vw] h-[4.6vh] bg-[#515152] flex items-center justify-center gap-2 hover:bg-opacity-75 rounded-lg cursor-not-allowed"
            >
              Approve
              <img src={approve} alt="" className="w-[1.56vw]" />
            </button>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center gap-[110px] mt-[3.19vh] mb-[5.5vh] ">
        <button
          onClick={() => {
            if (_fromDashborrow) {
              _setFromDashborrow(false);
              navigate("/dashboard");
            } else {
              navigate("/info");
            }
          }}
          className="border border-[#009FBD] w-[164px] h-[5.95vh] rounded-lg flex items-center justify-center gap-2 bg-inherit hover:opacity-75 "
        >
          <img src={back} alt="" />
          Back
        </button>
        <button
          id="vm-next-btn"
          className="bg-[#585858] w-[164px] h-[5.95vh] rounded-lg flex items-center justify-center gap-2  hover:bg-opacity-75 "
          onClick={handleNextButton}
        >
          Next
          <img src={next} alt="" onLoad={onLoaded} />
        </button>
      </div>
    </div>
  );
}

export default VaultMgt;
